const getCookie = (cname) => {
  const name = `${cname}=`;
  const cookieList = document.cookie.split(";");
  for (let i = 0; i < cookieList.length; i++) {
    const cookieItem = cookieList[i]?.trim();
    if (cookieItem.indexOf(name) === 0) {
      return cookieItem.split("=")[1];
    }
  }
  return "";
};

export const getAuthorizationToken = (name) => {
  const domain = window.location.host;

  if (
    domain.indexOf("developer.gartner.com") !== -1 ||
    domain.indexOf("tools-ha.pdotoolsqa.aws.gartner.com") !== -1
  ) {
    return getCookie(name);
  }
  return localStorage.getItem(name);
};
